export const TOGGLE_LOADING = 'verification/TOGGLE_LOADING'
export const TOGGLE_SUCCESS = 'verification/TOGGLE_SUCCESS'
export const TOGGLE_ERROR = 'verification/TOGGLE_ERROR'
export const SET_PHONE = 'verification/SET_PHONE'
export const SET_IIN = 'verification/SET_IIN'
export const SET_QR = 'verification/SET_QR'
export const SET_QR_KEY = 'verification/SET_QR_KEY'
export const GET_QR_STATUS = 'verification/GET_QR_STATUS'
export const TOGGLE_SUCCESS_SEND = 'verification/TOGGLE_SUCCESS_SEND'
export const TOGGLE_ERROR_SEND = 'verification/TOGGLE_ERROR_SEND'
export const RESET_VERIFICATION = 'verification/RESET_VERIFICATION'

export const SET_SMS_IIN_PHONE = 'verification/SET_SMS_IIN_PHONE'
export const SET_SMS_IIN_PHONE_DONE = 'verification/SET_SMS_IIN_PHONE_DONE'
export const SET_SMS_IIN_PHONE_FAIL = 'verification/SET_SMS_IIN_PHONE_FAIL'

export const SET_SMS_SEND = 'verification/SET_SMS_SEND'
export const SET_SMS_SEND_DONE = 'verification/SET_SMS_SEND_DONE'
export const SET_SMS_SEND_FAIL = 'verification/SET_SMS_SEND_FAIL'

export const STEP_NAME = 'verification/STEP_NAME'
